<template>
  <div id="contact" class="bg-dark text-light py-5">
    <div class="container">
      <h1 class="title">{{ $t('section.contact') }}</h1>
      <hr class="w-25 bg-light mt-1"/>

      <h3 class="text-center">{{ $t('contact.description') }}</h3>
      <form class="mx-auto" style="max-width: 800px;" @submit.prevent="send" novalidate="" ref="form">
        <div class="form-row">
          <div class="form-group col-md-6">
            <label for="contact_name">{{ $t('contact.name') }}</label>
            <input type="text" class="form-control" id="contact_name" name="contact[name]" :placeholder="$t('contact.name')" maxlength="120" v-model="name" required>
            <div class="invalid-feedback">
              {{ $t('contact.validation.name') }}
            </div>
          </div>
          <div class="form-group col-md-6">
            <label for="contact_email">{{ $t('contact.email') }}</label>
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text fas fa-envelope" id="emailPrepend"></span>
              </div>
              <input type="email" class="form-control" id="contact_email" name="contact[email]" :placeholder="$t('contact.email')" maxlength="255" aria-describedby="emailPrepend" v-model="email" required>
              <div class="invalid-feedback">
                {{ $t('contact.validation.email') }}
              </div>
            </div>
          </div>
        </div>
        <div class="form-group">
          <label for="contact_message">{{ $t('contact.message') }}</label>
          <textarea class="form-control" id="contact_message" name="contact[message]" :placeholder="$t('contact.message')" maxlength="1024" v-model="message" required></textarea>
          <div class="invalid-feedback">
            {{ $t('contact.validation.message') }}
          </div>
        </div>
        <button type="submit" class="btn btn-primary"><i class="far fa-paper-plane"></i> {{ $t('action.send') }}</button>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'contact',
  data: () => ({
    name: '',
    email: '',
    message: ''
  }),
  methods: {
    send (event) {
      let form = event.target
      if (form.checkValidity() === false) {
        event.preventDefault()
        event.stopPropagation()
        form.classList.add('was-validated')
      } else {
        form.classList.add('was-validated')
        if (this.name !== '' && this.email !== '' && this.message !== '') {
          window.jQuery.ajax({
            url: '/mtome.php',
            type: 'POST',
            data: window.jQuery(event.target).serialize(),
            success: (data) => {
              window.swal({
                title: this.$t('thank_you'),
                text: this.$t('contact.answer'),
                icon: 'success',
                button: this.$t('great')
              })
            }
          })
        }
      }
    }
  }
}
</script>
